import React from 'react';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';

interface FlatDashboardCardProps {
  children: React.ReactNode;
  className?: string;
}

const FlatDashboardCard: React.FC<FlatDashboardCardProps> = ({ 
  children, 
  className 
}) => {
  return (
    <motion.div 
      className={cn(
        "relative rounded-3xl p-6 backdrop-blur-sm transition-all duration-200",
        "bg-gradient-to-br from-white/60 to-white/40 dark:from-black/60 dark:to-black/40",
        "shadow-[0_4px_20px_-1px_rgba(0,0,0,0.05)] group",
        className
      )}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
      whileHover={{ 
        y: -5,
        transition: { duration: 0.5, ease: "easeInOut" }
      }}
    >
      {children}
    </motion.div>
  );
};

export default FlatDashboardCard;
